import { render, staticRenderFns } from "./BalanceOverview.vue?vue&type=template&id=3dd1c27a&scoped=true"
import script from "./BalanceOverview.vue?vue&type=script&lang=js"
export * from "./BalanceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd1c27a",
  null
  
)

export default component.exports